export default {
    link: {
        color: 'rgb(21, 40, 120)'
    },
    boldLink: {
        color: 'rgb(21, 40, 120) !important',
        fontWeight: 'bold'
    },
    savedCardHeader: {
        background: 'rgb(21, 40, 120) !important',
        color: 'white'
    },
    savedCard: {
        background: '#eee'
    }
};
